import { RestCompetitonResult } from '@/types'
import { sleep } from '@/utils/sleep'

class CompetitionRestMock {
  async subscribe (campaignId: number, email: string, name: string, country: string): Promise<RestCompetitonResult> {
    await sleep(1200)

    return {
      display_name: 'Taylor Fan No1',
      email: 'ilovetaylorswift@example.com',
      country_code: 'DE',
      id: 44,
      signed_up_at: '2022-01-13T13:09:54.509Z',
      user_id: 12,
      authenticated: true
    }
  }
}

export default new CompetitionRestMock()
